import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import type { RouteGuard } from './guards/RouteGuard'
import { RequiresAuthGuard } from './guards/RequiresAuthGuard'
import { RequiresStudentGuard } from './guards/RequiresStudentGuard'
import { RequiresLegalConsentGuard } from './guards/RequiresLegalConsentGuard'

class GuardRegistry {
  private guards: RouteGuard[] = []

  register(guard: RouteGuard): void {
    this.guards.push(guard)
  }

  async executeGuards(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ): Promise<void> {
    for (const guard of this.guards) {
      const result = await guard.canActivate(to, from)

      if (result === false) {
        next(false)
        return
      }

      if (typeof result === 'string') {
        next(result)
        return
      }
    }

    next()
  }

  clear(): void {
    this.guards = []
  }
}

export const guardRegistry = new GuardRegistry()

export function registerDefaultGuards(): void {
  guardRegistry.register(new RequiresAuthGuard())
  guardRegistry.register(new RequiresStudentGuard())
  // Después de la autenticación: sólo evalúa con sesión (ADR-SEC-013 local).
  guardRegistry.register(new RequiresLegalConsentGuard())
}
